(function($) {

    //socials
    $('body').on('click', '.social-btn', function(e){
        e.preventDefault();
        PopupCenter($(this).attr('href'), "KWR - Share Publication", 600, 420);

    });
    //close fb popup
    if( window.location.hash.indexOf("#facebook-close") > -1){
        window.close();
    }
}(jQuery, window, window.document));

//center popup
function PopupCenter(url, title, w, h) {
    // Fixes dual-screen position  Most browsers      Firefox
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}